import React, { type FC } from 'react';
import css from '../../TemplatesMainPage.scss';
import { Box, Cell, Layout, Text, TextButton } from '@wix/design-system';
import { DataHooks } from '../../../../constants/dataHooks';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { useMobile } from '../../../../hooks/useMobile';
import { ExternalLink } from '@wix/wix-ui-icons-common';
import { useTemplatesPageBi } from '../../../../hooks/useTemplatesPageBi';
import { DOCS } from '../../../../constants/routes';

export const HeadingSection: FC = () => {
  const { isMobile } = useMobile();
  const { t } = useTranslation();
  const { reportClickOnDocs } = useTemplatesPageBi();

  return (
    <Box
      gap="SP3"
      width="80%"
      margin="auto"
      padding="48px 0"
      maxWidth="1100px"
      direction="vertical"
    >
      <Layout cols={5} alignItems="center">
        <Cell span={3}>
          <Text
            className={css.headerPriorTitleText}
            dataHook={DataHooks.MainPagePriorTitle}
          >
            {t('app.main-page.prior.title')}
          </Text>
        </Cell>
        <Cell span={3}>
          <Text
            weight="thin"
            className={css.headerTitleText}
            dataHook={DataHooks.MainPageTitle}
          >
            <Trans i18nKey="app.main-page.title" components={[<br />]} />
          </Text>
        </Cell>
        {!isMobile && (
          <Cell span={2}>
            <Text dataHook={DataHooks.MainPageHeaderDescription}>
              {t('app.main-page.main.header.description')}{' '}
            </Text>
            <TextButton
              dataHook={DataHooks.MainPageTitleLink}
              onClick={() => {
                const docsUrl = DOCS.all;
                reportClickOnDocs('all', docsUrl);
                window.open(docsUrl);
              }}
              suffixIcon={<ExternalLink />}
            >
              <Trans
                i18nKey="app.main-page.main.header.description.link"
                components={[<br />]}
              />
            </TextButton>
          </Cell>
        )}
      </Layout>
    </Box>
  );
};
